import { Bell, Bot, Building2, ChevronDown, CircleDollarSign, LayoutDashboard, Phone, Route, ShieldCheck, UsersRound } from 'lucide-react'
import type { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

const nav = [
  ['Overview','/',LayoutDashboard],['Calls','/calls',Phone],['Directory','/directory',UsersRound],['Routing','/routing',Route],['PBX Sites','/pbx-sites',Building2],['AI Models','/ai-models',Bot],['Usage & Costs','/usage',CircleDollarSign],['Alerts','/alerts',Bell],['Access & Audit','/access',ShieldCheck],
] as const
export default function AppShell({children}:{children:ReactNode}){
  return <div className="app-shell">
    <aside className="sidebar">
      <div className="brand"><BrandMark/><span>RelayDesk</span></div>
      <div className="tenant-label">Tenant</div>
      <button className="tenant-switcher"><Building2 size={16}/><span>Northstar Dental Group</span><ChevronDown size={15}/></button>
      <nav aria-label="Main navigation">{nav.map(([label,to,Icon])=><NavLink key={label} to={to} aria-label={label} end={to==='/' } className={({isActive})=>isActive?'nav-link active':'nav-link'}><Icon size={19}/><span>{label}</span></NavLink>)}</nav>
      <div className="sidebar-foot"><div className="avatar">AL</div><div><strong>Alex Lopez</strong><span>Operator</span></div><ChevronDown size={15}/></div>
    </aside>
    <main className="workspace">{children}</main>
  </div>
}

function BrandMark(){return <svg className="brand-mark" viewBox="0 0 32 32" role="img" aria-label="RelayDesk"><path d="M14 3 3 16l11 13 5-6-6-7 6-7Z"/><path d="m21 3-6 7 6 6-6 7 6 6 11-13Z"/></svg>}
